<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentUnpaid.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentUnpaid.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="fetching">
              <form>
                <fieldset>
                  <legend>{{ $t('studentUnpaid.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.branchName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentUnpaid.acYear')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.ac_year_id"
                        :options="ac_year_list"
                        @change="acYearChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentUnpaid.mainProgram')
                      }}</label>
                      <treeselect
                        :options="main_programs"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.acp_id"
                        @input="onMainProgramChange"
                        :disabled="!model.ac_year_id"
                        :maxHeight="150"
                      ></treeselect>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentUnpaid.subProgram')
                      }}</label>
                      <treeselect
                        :options="sub_programs"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.acps_id"
                        @input="onSubChange"
                        :disabled="!model.ac_year_id"
                        :maxHeight="150"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('studentUnpaid.acTerm') }} &nbsp;</label>
                      <label>
                        <ts-checkbox v-model="is_term_history">
                          {{ $t('report.history') }}
                        </ts-checkbox>
                      </label>
                      &nbsp;
                      <label>
                        <ts-checkbox v-model="is_term_next">{{
                          $t('Next')
                        }}</ts-checkbox></label
                      >
                      <treeselect
                        :options="terms"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.ac_term_id"
                        :maxHeight="150"
                        @input="acTermChange"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlyPaymentList.classOperation')
                      }}</label>
                      <treeselect
                        :options="class_options"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.class_id"
                        :maxHeight="150"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('studentList.reportType') }}</label>
                      <div class="form-group">
                        <div class="radio radio-css radio-inline">
                          <input
                            v-model="model.report_status"
                            type="radio"
                            id="Detail"
                            :value="'Detail'"
                          />
                          <label for="Detail">
                            {{ $t('report.detail') }}
                          </label>
                        </div>
                        <div class="radio radio-css radio-inline">
                          <input
                            v-model="model.report_status"
                            type="radio"
                            id="Summary"
                            :value="'Summary'"
                          />
                          <label for="Summary">
                            {{ $t('report.summary') }}
                          </label>
                        </div>
                        <div class="radio radio-css radio-inline">
                          <input
                            v-model="model.report_status"
                            type="radio"
                            id="byClass"
                            :value="'byClass'"
                          />
                          <label for="byClass">
                            {{ $t('report.byClass') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('studentUnpaid.feeType') }}</label>
                      <treeselect
                        :options="feeTypes"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.fee_type_id"
                        :maxHeight="150"
                        :disabled="model.report_status === 'Summary'"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('fee_type_id')">
                        {{ errors.first('fee_type_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <!-- <ts-button
                        v-if="model.report_status == 'Detail'"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        >{{ $t('excel') }}</ts-button
                      > -->
                      <ts-button
                        class="ml-2 mr-2"
                        color="primary"
                        outline
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('studentUnpaid.previewPdf') }}</ts-button
                      >
                      <ts-button
                        color="primary"
                        @click.prevent="fetchData"
                        :waiting="loading"
                        >{{ $t('view') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card v-if="preview_pdf">
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('studentUnpaid.previewPdf') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
        <ts-card v-else>
          <ts-table
            v-if="model.report_status == 'Detail'"
            :columns="columns"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'student_name_full_info'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">{{ record.fee_type }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.fee_name_en }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.class_id }}</td>
              <td class="ts-whitespace-no-wrap">
                {{
                  record.class_name +
                    '_' +
                    record.room_name +
                    '_' +
                    record.study_time
                }}
              </td>
              <td class="ts-whitespace-no-wrap">{{ record.teacher_name }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.due_date }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.late_day }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                {{ '$ ' + format_number(record.amount_paid) }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                {{ '$ ' + format_number(record.amount_due) }}
              </td>
              <td class="ts-whitespace-no-wrap">{{ record.term_name }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.term_start }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.term_stop }}
              </td>
            </template>
          </ts-table>          
          <ts-table
            v-if="model.report_status == 'byClass'"
            :columns="columnsClass"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'class_group'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">{{ record.card_id + '-' + record.student_name }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.fee_type }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.fee_name_en }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.class_id }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.due_date }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.late_day }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                {{ '$ ' + format_number(record.amount_paid) }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                {{ '$ ' + format_number(record.amount_due) }}
              </td>
              <td class="ts-whitespace-no-wrap">{{ record.term_name }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.term_start }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.term_stop }}
              </td>
            </template>
          </ts-table>
          <ts-table
            v-if="model.report_status == 'Summary'"
            :columns="columnsSummary"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'main_program'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">{{ record.sub_program }}</td>
              <td class="ts-whitespace-no-wrap">
                {{ record.term_name }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.total_student }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ '$ ' + format_number(record.invoice_amount) }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ '$ ' + format_number(record.amount_paid) }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ '$ ' + format_number(record.amount_due) }}
              </td>
            </template>
          </ts-table>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as FileDownload from 'downloadjs'
import { Errors } from 'form-backend-validation'
import { trim } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'studentUnpaid',
  data() {
    return {
      loading: false,
      waiting: false,
      fetching: false,
      visible: false,
      exporting: false,
      preview_pdf: true,
      src: '',
      errors: new Errors(),
      branches: [],
      main_programs: [],
      sub_programs: [],
      history_terms: [],
      class_options: [],
      terms: [],
      feeTypes: [],
      ac_terms: [],
      next_terms: [],
      ac_year_list: [],
      fee_types: [],
      is_term_history: false,
      is_term_next: false,
      model: {
        branch_id: null,
        ac_year_id: null,
        report_status: 'Detail',
        acp_id: [],
        acps_id: [],
        ac_term_id: [],
        class_id: [],
        fee_type_id: []
      }
    }
  },
  computed: {
    ...mapState('reportPayment', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('studentUnpaid.feeType') },
        { name: this.$t('studentUnpaid.feeName') },
        { name: 'Class ID' },
        { name: this.$t('studentUnpaid.class') },
        { name: this.$t('studentUnpaid.teacher') },
        { name: this.$t('studentUnpaid.dueDate'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.lateDay'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.paid'), style: 'text-align:right' },
        { name: this.$t('studentUnpaid.due'), style: 'text-align:right' },
        { name: this.$t('studentUnpaid.term') },
        { name: this.$t('studentUnpaid.start'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.stop'), style: 'text-align:center' }
      ]
    },    
    columnsClass() {
      return [
        { name: this.$t('studentUnpaid.studentName') },
        { name: this.$t('studentUnpaid.feeType') },
        { name: this.$t('studentUnpaid.feeName') },
        { name: 'Class ID' },
        { name: this.$t('studentUnpaid.dueDate'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.lateDay'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.paid'), style: 'text-align:right' },
        { name: this.$t('studentUnpaid.due'), style: 'text-align:right' },
        { name: this.$t('studentUnpaid.term') },
        { name: this.$t('studentUnpaid.start'), style: 'text-align:center' },
        { name: this.$t('studentUnpaid.stop'), style: 'text-align:center' }
      ]
    },
    columnsSummary() {
      return [
        { name: this.$t('studentUnpaid.program') },
        { name: this.$t('studentUnpaid.termName') },
        { name: this.$t('studentUnpaid.total'), style: 'text-align:center' },
        {
          name: this.$t('studentUnpaid.invoiceAmount'),
          style: 'text-align:center'
        },
        {
          name: this.$t('studentUnpaid.amountPaid'),
          style: 'text-align:center'
        },
        {
          name: this.$t('studentUnpaid.amountDue'),
          style: 'text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchPreData()
  },
  methods: {
    ...mapActions('reportPayment', [
      'studentUnpaid',
      'getMainProgram',
      'getSubProgram',
      'getTerm',
      'getYear',
      'getClass',
      'fetchFeeType',
      'getBranch'
    ]),
    format_number(value) {
      return parseFloat(value).toFixed(2)
    },
    fetchData(attributes) {
      this.preview_pdf = false
      this.loading = true
      this.$store
        .dispatch(
          'reportPayment/fetchStudentUnpaid',
          Object.assign(this.model, { ...attributes })
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async fetchPreData() {
      this.fetching = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      await this.getMainProgram().then(response => {
        this.main_programs = response.data.map(el => ({
          id: el.acp_id,
          label: el.acp_name_foreign
        }))
      })
      await this.fetchFeeType({ fee_type_id: '1,2,3' })
        .then(response => {
          this.fee_types = response.data.map(el => ({
            id: el.fee_type_id,
            label: el.fee_type_name
          }))
          this.feeTypes = this.fee_types
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    onBranchChange() {
      this.model.ac_year_id = null
      this.model.acps_id = []
      this.model.ac_term_id = []
      this.fetching = true
      this.getYear({
        filter: {
          ac_status_id: '1,2,3',
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    onMainProgramChange() {
      this.model.acps_id = []
      this.model.ac_term_id = []
      this.model.class_id = []
      this.fetching = true
      if (this.model.acp_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getSubProgram({
        filter: {
          acp_id: this.model.acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
          this.model.acps_id = []
          response.data.map(el => this.model.acps_id.push(el.acps_id))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    onSubChange() {
      this.history_terms = []
      this.ac_terms = []
      this.terms = []
      this.class_options = []
      this.model.ac_term_id = []
      this.model.class_id = []
      this.fetching = true
      if (this.model.acps_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.history_terms = _.sortBy(response.data, ['ac_status_id'])
            .filter(t => t.ac_status_id == 2)
            .map(el => ({
              id: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            }))
          this.ac_terms = _.sortBy(response.data, ['ac_status_id'])
            .filter(t => t.ac_status_id == 1)
            .map(el => ({
              id: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            }))
          this.next_terms = _.sortBy(response.data, ['ac_status_id'])
            .filter(t => t.ac_status_id == 3)
            .map(el => ({
              id: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            }))
          this.model.ac_term_id = []
          this.terms = this.ac_terms
          this.terms.map(el => this.model.ac_term_id.push(el.id))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    acTermChange() {
      this.class_options = []
      this.model.class_id = []
      this.loading = true
      if (this.model.ac_term_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getClass({
        filter: {
          ac_term_id: this.model.ac_term_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            id: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time
          }))
          this.model.class_id = []
          response.data.map(el => this.model.class_id.push(el.class_id))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    acYearChange() {
      this.model.acp_id = []
      this.model.acps_id = []
      this.model.ac_term_id = []
      this.model.class_id = []
    },
    preview() {
      this.preview_pdf = true
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.studentUnpaid(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportPayment/studentUnpaidExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    'model.branch_id': function(val) {
      if (val) {
        this.onBranchChange()
      }
    },
    'model.report_status': function(val) {
      if (val) {
        this.$store.commit('reportPayment/RESET_STATE')
      }
      this.model.fee_type_id = []
      if (val == 'Summary') {
        this.feeTypes = this.fee_types.filter(f => f.id == 1)
        this.model.fee_type_id = [1]
      } else {
        this.feeTypes = this.fee_types
      }
    },
    is_term_history: function(val) {
      this.terms = []
      this.model.ac_term_id = []
      if (val) {
        this.is_term_next = false
        this.terms = this.history_terms
      } else if (!val && !this.is_term_next) {
        this.terms = this.ac_terms
      }
      this.terms.map(el => this.model.ac_term_id.push(el.id))
    },
    is_term_next: function(val) {
      this.terms = []
      this.model.ac_term_id = []
      if (val) {
        this.is_term_history = false
        this.terms = this.next_terms
      } else if (!val && !this.is_term_history) {
        this.terms = this.ac_terms
      }
      this.terms.map(el => this.model.ac_term_id.push(el.id))
    }
  }
}
</script>
